import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getTypes (query = '') {
    return ApiService.get(`admin/dashboards/types?${query}`)
  },

  async getCategories (query = '') {
    return ApiService.get(`admin/dashboards/categories?${query}`)
  }
}

export default DashboardService
